var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-1264 1220)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 141,
    height: 141,
    rx: 70,
    transform: "translate(1264 -1220)",
    fill: "#00a884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M835.938,394.452C831.851,324.7,765.5,324,765.5,324v70.452Z",
    transform: "translate(569 -1544)",
    fill: "#07886c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "box-11386",
    transform: "translate(1286.752 -1212.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M65.077,149.854a1.064,1.064,0,0,1-.4-.078L28.355,135.1a1.063,1.063,0,0,1-.665-.986V105.628a1.064,1.064,0,0,1,2.128,0V133.4l34.2,13.814v-44.18a1.064,1.064,0,0,1,2.128,0v45.758a1.064,1.064,0,0,1-1.064,1.064Z",
    transform: "translate(-17.207 -48.178)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M37.388,93.043a1.047,1.047,0,0,1-.4-.078L.665,78.291a1.064,1.064,0,0,1-.431-1.652L10.717,63.6a1.065,1.065,0,0,1,1.228-.32L48.269,77.958A1.064,1.064,0,0,1,48.7,79.61L38.218,92.645A1.062,1.062,0,0,1,37.388,93.043ZM2.79,76.854,37.054,90.7l9.089-11.3L11.879,65.552Z",
    transform: "translate(0 -24.09)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M124.7,149.854a1.064,1.064,0,0,1-1.064-1.064V103.033a1.064,1.064,0,0,1,2.128,0v44.181l34.2-13.814V105.628a1.064,1.064,0,0,1,2.128,0v28.489a1.064,1.064,0,0,1-.665.986L125.1,149.777A1.086,1.086,0,0,1,124.7,149.854Z",
    transform: "translate(-76.833 -48.178)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M135.187,93.042a1.064,1.064,0,0,1-.829-.4L123.876,79.61a1.064,1.064,0,0,1,.431-1.652l36.324-14.675a1.062,1.062,0,0,1,1.228.32l10.483,13.035a1.064,1.064,0,0,1-.431,1.652L135.586,92.964A1.056,1.056,0,0,1,135.187,93.042Zm-8.756-13.649,9.089,11.3,34.264-13.843L160.7,65.55Z",
    transform: "translate(-76.835 -24.089)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M101.4,41.244a1.077,1.077,0,0,1-.4-.078L65.076,26.652,29.15,41.167a1.064,1.064,0,0,1-.8-1.973L64.677,24.519a1.064,1.064,0,0,1,.8,0L101.8,39.194a1.064,1.064,0,0,1-.4,2.05Z",
    transform: "translate(-17.205 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M124.7,55.919a1.064,1.064,0,0,1-1.064-1.064V25.505a1.064,1.064,0,0,1,2.128,0v29.35A1.064,1.064,0,0,1,124.7,55.919Z",
    transform: "translate(-76.833)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.49181b5783fab2678040c4df484c2e6c.svg";
export { ForwardRef as ReactComponent };